/**
 * Application entry point.
 *
 * Initializes the event delegation system and loads all handlers.
 */

import { init } from './delegator.js';
import './handlers.js';

init();
